import { useAppSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { useMemo } from 'react';
import { htcmdService } from 'js/services/htcmd.service';

export const useSkipAutoLoginDependency = () => {
    const {
        casinoName,
        skipAutoLoginDependency
    } = useAppSelector(pick(['casinoName', 'skipAutoLoginDependency']));

    return useMemo(() => {
        return skipAutoLoginDependency
            && !document.cookie.includes(`pas[${casinoName}][real][isOnline]=1`)
            && !new URLSearchParams(location.search).has('username')
            && !htcmdService.isEnabled
            && !htcmdService.isWrapperEnabled;
    }, [
        casinoName,
        skipAutoLoginDependency
    ]);
};
